import * as React from "react";

const SvgSpacesIcon = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={4} y={4} width={7.38462} height={7.38462} rx={1.23077} fill="#7D4CB5" /><rect x={12.6154} y={4} width={7.38462} height={16} rx={1.23077} fill="#C196F7" /><rect x={4} y={12.6146} width={7.38462} height={7.38462} rx={1.23077} fill="#9B63E6" /></svg>;

export default SvgSpacesIcon;